<template lang="pug">
  .social
    a(:href="facebookUrl" target="_blank")
      figure
        img(src="/static/icons/facebook.svg")
    a(:href="twitterUrl" target="_blank")
      figure
        img(src="/static/icons/twitter.svg")
    a(:href="emailUrl")
      figure
        img(src="/static/icons/email.svg")
</template>

<script>

export default {
  name: 'social',
  props: ['meta'],

  computed: {
    facebookUrl: function () {
      let url = 'https://www.facebook.com/sharer/sharer.php?'
      url += 'u=' + this.meta.url
      url += '&title=' + this.meta.title
      // url += '&description=' + this.meta.description
      return url
      // facebookShareLink: function () {
      //   return 'https://www.facebook.com/dialog/share?app_id=2029816993710314&display=popup&href=' + this.pageURLFacebook + '&redirect_uri=' + this.pageURLFacebook
      // },
      // pageURLFacebook: function () {
      //   return window.location.href.replace(':', '%3A').replace('/', '%2F')
      // },
    },

    twitterUrl: function () {
      let url = 'https://twitter.com/intent/tweet?'
      url += 'url=' + this.meta.url
      url += '&text=' + encodeURI(this.meta.title)
      return url
    },

    emailUrl: function () {
      let url = 'mailto:?subject=CAAM: ' + this.meta.title
      url += '&body=' + this.meta.url
      return url
    }
  }
}
</script>

<style lang="sass">
  .social
    display: flex
    justify-content: flex-start
    figure
      margin: 0
      margin-right: 10px
      margin-top: 1rem
      width: 20px
      img
        width: 100%
</style>



// WEBPACK FOOTER //
// social.vue?be1e87e0